import { FeaturedType } from 'root/clientTypes';

/**
 * Highlight types an item can be badged with. Mirrors the order offered in the
 * business manager so that what an owner picks there reads the same here.
 */
export const ALL_FEATURED_TYPES = 'all';

export const FEATURED_TYPES: FeaturedType[] = [
  FeaturedType.POPULAR,
  FeaturedType.BEST_SELLER,
  FeaturedType.NEW,
  FeaturedType.CHEF_SPECIAL,
  FeaturedType.RECOMMENDED,
  FeaturedType.SEASONAL,
  FeaturedType.FEATURED,
];

const featuredTypeTranslationKeys: Record<FeaturedType, string> = {
  [FeaturedType.POPULAR]: 'app.item.featured-badge.popular',
  [FeaturedType.BEST_SELLER]: 'app.item.featured-badge.best-seller',
  [FeaturedType.NEW]: 'app.item.featured-badge.new',
  [FeaturedType.CHEF_SPECIAL]: 'app.item.featured-badge.chef-special',
  [FeaturedType.RECOMMENDED]: 'app.item.featured-badge.recommended',
  [FeaturedType.SEASONAL]: 'app.item.featured-badge.seasonal',
  [FeaturedType.FEATURED]: 'app.item.featured-badge.featured',
  [FeaturedType.UNKNOWN_FEATURED_TYPE]: '',
};

/**
 * A type the site does not recognise — either unset, explicitly unknown, or added
 * to the API after this version — has no badge to show.
 */
export const isSupportedFeaturedType = (type?: FeaturedType): type is FeaturedType =>
  !!type && FEATURED_TYPES.includes(type);

export const getFeaturedTypeTranslationKey = (type: FeaturedType) => featuredTypeTranslationKeys[type];
